
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Tempotravelleronrentinpune() {



    const cardData =
    {
        keyword: ' Tempo Traveller On Rent in Pune',
        heading: 'Mauli Cabs:  Tempo Traveller On Rent in Pune ',
        headingDescription: 'Mauli Cabs offers comfortable and affordable Tempo Traveller on rent in Pune, perfect for group travels, family outings, and corporate trips. Our well-maintained fleet includes spacious and modern Tempo Travellers that can accommodate large groups while ensuring a smooth, safe, and enjoyable ride. With experienced drivers, transparent pricing, no hidden charges, and a focus on punctuality and customer satisfaction, Mauli Cabs guarantees a hassle-free travel experience for all your group journeys in and around Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with rich historical significance and panoramic views of the Sahyadri hills."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved out of a single basalt rock, Pataleshwar Cave Temple is dedicated to Lord Shiva and offers a peaceful spiritual retreat."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, this temple is known for its rich history, beautiful idol, and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts showcasing Indian arts, crafts, and culture, curated by Dr. Dinkar Kelkar."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering a temple complex atop a hill with stunning views of the city."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, Osho Ashram is a spiritual retreat offering meditation programs and a serene environment, attracting visitors from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Also known as Pu La Deshpande Garden, this is a Japanese-style landscape garden perfect for relaxing walks and photography."
    },
    {
        "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
        "description": "This zoo and snake park features a wide variety of reptiles and animals, making it a favorite spot for families and children."
    }
],

"services": [
    {
      "name": "17 Seater Tempo Traveller on Rent in Pune",
      "description": "Rent a 17-seater tempo traveller in Pune for group travel, family trips, or corporate outings. Spacious, air-conditioned, and driven by professionals for safe long-distance travel."
    },
    {
      "name": "13 Seater Tempo Traveller on Rent in Pune",
      "description": "Hire a 13-seater tempo traveller in Pune ideal for small groups or outstation trips. Enjoy comfortable seating, luggage space, and experienced chauffeurs."
    },
    {
      "name": "Traveller on Rent Pune",
      "description": "Get tempo travellers on rent in Pune for all your travel needs. Available in AC and non-AC variants with seating capacity from 12 to 20 passengers."
    },
    {
      "name": "Traveller Bus on Rent in Pune",
      "description": "Book a traveller bus in Pune for weddings, tours, and corporate events. Clean interiors, reclining seats, and experienced drivers make group travel convenient."
    },
    {
      "name": "17 Seater Bus Rate per km in Pune",
      "description": "Know the per km rate for renting a 17-seater bus in Pune. Transparent pricing with no hidden charges for outstation or local use."
    },
    {
      "name": "17 Seater Tempo Traveller in Pune",
      "description": "Comfortable and reliable 17-seater tempo travellers available in Pune for city tours or intercity travel. Equipped with AC, music system, and charging points."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent Pune",
      "description": "Book a 17-seater tempo traveller on rent in Pune for weddings, pilgrimages, or weekend trips. Affordable rates and comfortable ride experience."
    },
    {
      "name": "20 Seater Tempo Traveller Pune",
      "description": "Spacious 20-seater tempo travellers in Pune for large group travel. Best suited for corporate team outings, school trips, or long-distance tours."
    },
    {
      "name": "20 Seater Bus on Rent in Pune",
      "description": "Hire a 20-seater bus in Pune for bulk transport needs. AC and non-AC options available with flexible packages and trained drivers."
    },
    {
      "name": "25 Seater Bus Rate per km Pune",
      "description": "Check competitive per km rates for renting a 25-seater bus in Pune. Ideal for large events, tours, and organization transport with customized packages."
    },
    {
      "name": "AC Tempo Traveller on Rent in Pune",
      "description": "Rent AC tempo travellers in Pune with clean interiors and smooth suspension for maximum comfort on road trips or city transfers."
    },
    {
      "name": "Book Tempo Online Pune",
      "description": "Instantly book a tempo traveller online in Pune. Choose seating capacity, AC/non-AC, and confirm with secure online payments."
    },
    {
      "name": "Book Tempo Traveller in Pune",
      "description": "Easy booking of tempo travellers in Pune for outstation and local travel. Flexible rental options and verified drivers provided."
    },
    {
      "name": "Hire Tempo in Pune",
      "description": "Hire tempo vans in Pune at affordable daily or per km rates. Suitable for goods, people transport, and wedding logistics."
    },
    {
      "name": "Hire Tempo Traveller in Pune",
      "description": "Tempo traveller hire services in Pune for corporate, tourism, and personal travel. Vehicles are sanitized, GPS-enabled, and comfortable."
    },
    {
      "name": "Luxury Tempo Traveller on Rent in Pune",
      "description": "Book luxury tempo travellers in Pune with leather seats, mood lighting, LCD TVs, and premium sound systems. Ideal for VIP and executive tours."
    },
    {
      "name": "Pune Tempo Traveller Hire for Outstation",
      "description": "Outstation tempo traveller hire from Pune with door-to-door pickup, route planning, and multi-day rental packages available."
    },
    {
      "name": "Pune to Mahabaleshwar Tempo Traveller",
      "description": "Hire a tempo traveller for a Pune to Mahabaleshwar trip. Perfect for weekend getaways with friends or family, with optional sightseeing stops."
    },
    {
      "name": "Pune to Shirdi Tempo Traveller Rate",
      "description": "Check tempo traveller rental rates for Pune to Shirdi trips. Fixed and per km pricing options for a peaceful pilgrimage journey."
    },
    {
      "name": "Tempo Traveller Hire in Pune",
      "description": "Hire tempo travellers in Pune for all travel needs—local, outstation, or event-based. Variety of seating configurations and affordable plans available."
    },
    {
      "name": "Tempo Traveller on Rent in Pune Rate per km",
      "description": "Know exact per km rates for tempo traveller rental in Pune. Transparent fare breakdowns and no hidden costs."
    },
    {
      "name": "Tempo Traveller Rental Pune",
      "description": "Affordable and trusted tempo traveller rental services in Pune with AC, luxury, and standard options for all group sizes and budgets."
    }
  ],
  "tableData": [
    ["17 Seater Tempo Traveller on Rent in Pune", "13 Seater Tempo Traveller on Rent in Pune"],
    ["Traveller on Rent Pune", "Traveller Bus on Rent in Pune"],
    ["17 Seater Bus Rate per km in Pune", "17 Seater Tempo Traveller in Pune"],
    ["17 Seater Tempo Traveller on Rent Pune", "20 Seater Tempo Traveller Pune"],
    ["20 Seater Bus on Rent in Pune", "25 Seater Bus Rate per km Pune"],
    ["AC Tempo Traveller on Rent in Pune", "Book Tempo Online Pune"],
    ["Book Tempo Traveller in Pune", "Hire Tempo in Pune"],
    ["Hire Tempo Traveller in Pune", "Luxury Tempo Traveller on Rent in Pune"],
    ["Pune Tempo Traveller Hire for Outstation", "Pune to Mahabaleshwar Tempo Traveller"],
    ["Pune to Shirdi Tempo Traveller Rate", "Tempo Traveller Hire in Pune"],
    ["Tempo Traveller on Rent in Pune Rate per km", "Tempo Traveller Rental Pune"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Spacious and Comfortable Travel",
        "WhyChoosedescription": "Mauli Cabs offers well-maintained Tempo Travellers in Pune with spacious seating, ample legroom, and air-conditioning—ideal for group travel, family outings, or corporate trips."
    },
    {
        "WhyChooseheading": "Multiple Seating Capacities",
        "WhyChoosedescription": "Choose from 9, 12, 17, and 20-seater Tempo Travellers based on your group size. Whether it's a small family function or a large team event, we have the right vehicle for you."
    },
    {
        "WhyChooseheading": "Experienced Group Travel Drivers",
        "WhyChoosedescription": "Our drivers are experienced in handling group tours and outstation trips. They are courteous, punctual, and ensure a smooth and safe journey for everyone on board."
    },
    {
        "WhyChooseheading": "Perfect for All Occasions",
        "WhyChoosedescription": "From weddings and picnics to corporate tours and religious trips, our Tempo Travellers are suitable for all kinds of travel needs across Pune and beyond."
    },
    {
        "WhyChooseheading": "Affordable Group Travel Solutions",
        "WhyChoosedescription": "Get competitive rates with no hidden charges. Mauli Cabs offers transparent pricing and value-for-money Tempo Traveller rentals for both local and outstation use."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop",
        "WhyChoosedescription": "Enjoy the convenience of pickup and drop from your location in Pune. Our drivers ensure timely service right from your doorstep."
    },
    {
        "WhyChooseheading": "Well-Maintained and Clean Vehicles",
        "WhyChoosedescription": "All our Tempo Travellers are regularly serviced and cleaned before every trip, ensuring a hygienic and comfortable environment for your group."
    },
    {
        "WhyChooseheading": "24/7 Booking and Support",
        "WhyChoosedescription": "Our Tempo Traveller rentals in Pune are available round the clock. Book anytime online, and our support team is ready to assist you with route planning and travel coordination."
    }
]





















    }


    const faqData = [
        {
            question: 'How do I book a Tempo Traveller on rent in Pune with Mauli Cabs?',
            answer: 'Booking a Tempo Traveller in Pune is simple with Mauli Cabs. You can visit our website or app, choose "Tempo Traveller" under vehicle options, enter your trip details, and confirm your booking. You can also call our customer support for group travel arrangements.',
        },
        {
            question: 'What seating options are available in Tempo Travellers?',
            answer: 'We offer Tempo Travellers in various seating configurations including 9-seater, 12-seater, 17-seater, and 20-seater models. Choose according to your group size and comfort preferences.',
        },
        {
            question: 'Is Tempo Traveller rental available for local and outstation trips?',
            answer: 'Yes, our Tempo Travellers are available for both local travel within Pune and outstation trips to destinations like Lonavala, Mahabaleshwar, Goa, Shirdi, and more.',
        },
        {
            question: 'Are the Tempo Travellers air-conditioned and comfortable?',
            answer: 'Absolutely. All our Tempo Travellers are well-maintained, clean, and equipped with air-conditioning, push-back seats, and ample luggage space to ensure a comfortable ride for all passengers.',
        },
        {
            question: 'Is there a fixed rental rate for Tempo Travellers?',
            answer: 'Yes, we offer competitive and transparent pricing based on the vehicle type, number of kilometers, and trip duration. The fare includes driver charges and fuel, with no hidden costs.',
        },
        {
            question: 'Can I book a Tempo Traveller for weddings, corporate events, or group tours?',
            answer: 'Yes, we provide Tempo Travellers for weddings, corporate outings, school trips, and family tours. Just let us know your event type, and we’ll arrange the right vehicle for your group.',
        },
        {
            question: 'Are drivers experienced in handling large group travel?',
            answer: 'Yes, our drivers are well-trained, licensed, and experienced in driving Tempo Travellers for both short and long distances, ensuring safety and comfort throughout the journey.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rohit Pawar",
            position: "Event Organizer",
            text: "We rented a 17-seater Tempo Traveller from Mauli Cabs for a wedding function. The vehicle was clean and very comfortable, and the driver was punctual and professional. Excellent group travel service!",
            image: "/img/testimonial/testimonial-thumb-1-11.png",
        },
        {
            name: "Mrs. Anjali Naik",
            position: "Tour Planner",
            text: "Mauli Cabs provided a 12-seater Tempo Traveller for our Mahabaleshwar trip. It was spacious, well-maintained, and perfect for our group. We had a smooth and enjoyable journey!",
            image: "/img/testimonial/testimonial-thumb-1-12.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Tempo Traveller On Rent in Pune by Mauli Cabs",
        "description": "Mauli Cabs offers tempo traveller rentals in Pune for outstation trips, group travel, and local tours. Choose from 13, 17, 20, and 25-seater options with AC, luxury features, and professional drivers. Book online for affordable per-kilometer rates and round-the-clock service.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "6200"
        }
      };
      
    


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Tempo Traveller on Rent in Pune | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Hire 13, 17, 20, or 25-seater tempo travellers in Pune from Mauli Cabs. Luxury, AC, and group travel options available for Shirdi, Mahabaleshwar, and more. Book online with the best per km rates and professional service."
        />
        <meta
          name="keywords"
          content="17 seater tempo traveller on rent in pune, 13 seater tempo traveller on rent in pune, Traveller on rent Pune, Traveller bus on rent in pune, 17 Seater Bus Rate per km in pune, 17 Seater tempo traveller in pune, 17 seater tempo traveller on rent pune, 20 seater tempo traveller pune, 20 seater bus on rent in pune, 25 seater bus rate per km pune, ac tempo traveller on rent in pune, book tempo online pune, book tempo traveller in pune, Hire tempo in pune, Hire tempo traveller in pune, Luxury tempo traveller on rent in pune, Pune Tempo Traveller hire for outstation, Pune to Mahabaleshwar tempo traveller, Pune to shirdi tempo traveller rate, Tempo Traveller hire in Pune, Tempo traveller on rent in pune rate per km, Tempo traveller rental pune"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravelleronrentinpune;